__turbopack_context__.v({
  "root": "HRVCard-module__pX-FHa__root" + " " + __turbopack_context__.i(975967)["BentoCardSizeCss"],
});
